import { Link, Outlet, useLocation } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth-store'
import { LogOut } from 'lucide-react'

const steps = [
  { path: '/onboarding/profile', label: 'Profile', step: 1 },
  { path: '/onboarding/organization', label: 'Choose Path', step: 2 },
  { path: '/onboarding/create-organization', label: 'Company Setup', step: 3 }
]

export default function OnboardingLayout() {
  const location = useLocation()
  const { signOut, user } = useAuthStore()

  const handleLogout = async () => {
    await signOut()
  }

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      {/* Top bar with user info and logout */}
      <div className="absolute top-4 right-4 flex items-center gap-3">
        {user?.email && (
          <span className="text-sm text-muted-foreground hidden sm:inline">
            {user.email}
          </span>
        )}
        <Button
          variant="ghost"
          size="sm"
          onClick={handleLogout}
          className="text-muted-foreground hover:text-foreground"
        >
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </Button>
      </div>

      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Complete Onboarding</h1>
          <p className="text-muted-foreground">Set up your profile and organization to get started</p>
        </div>
        
        <div className="flex justify-center gap-2 mb-8">
          {steps.map((step) => {
            const active = location.pathname === step.path
            return (
              <Link
                key={step.path}
                to={step.path}
                className="no-underline transition-opacity hover:opacity-90"
              >
                <Badge
                  variant={active ? 'default' : 'outline'}
                  className={cn(
                    'px-4 py-2 text-sm cursor-pointer',
                    active && 'bg-primary text-primary-foreground',
                    !active && 'hover:border-primary/50'
                  )}
                >
                  {step.label}
                </Badge>
              </Link>
            )
          })}
        </div>
        
        <Card>
          <CardContent className="p-6">
            <Outlet />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
